export default (element) => {
  const menuListButtons = element.querySelectorAll('[data-footer-menu-list-title]');
  const skipToMain = document.querySelector('#skip_to_main');
  const menuLinkToggle = () => {
    menuListButtons.forEach((listItem) => listItem.addEventListener('click', () => {
      listItem.lastElementChild.classList.toggle('rotate-180');
      listItem.nextElementSibling.classList.toggle('hidden');
    }));
  };

  const focusManagement = () => {
    const footerLinks = element.querySelectorAll('a');  
    const lastFooterLink = footerLinks[footerLinks.length - 1];  

    lastFooterLink.addEventListener('keydown', (e) =>{
      if (e.key === 'Tab' && !e.shiftKey) { 
        e.preventDefault();
        skipToMain.focus();  
      }
    });
  };

  const init = () => {
    menuLinkToggle();
    focusManagement();
  };
  init();
};
